module.exports = __webpack_public_path__ + "img/icon_alert@3x.39a1b776.png";